    <div class="inner-page-bg-right">

        <section class="terms-content">
            <div class="container">
                <div class="terms-container">
                    <h1>Cookie Policy</h1>

                    <p>This Cookie Policy explains how Scanfluence uses cookies and similar tracking technologies on our website and applications. By using our Services, you consent to the use of cookies in accordance with this Policy.</p>

                    <h2>1. What Are Cookies?</h2>
                    <p>Cookies are small text files stored on your device when you visit a website. They help remember your preferences and improve your browsing experience.</p>

                    <h2>2. Types of Cookies We Use</h2>
                    <ul>
                        <li><strong>Essential Cookies:</strong> Necessary for website functionality and security.</li>
                        <li><strong>Performance Cookies:</strong> Collect anonymous usage data to help us improve performance.</li>
                        <li><strong>Functional Cookies:</strong> Remember user preferences and settings.</li>
                        <li><strong>Advertising Cookies:</strong> Deliver relevant ads and measure their effectiveness.</li>
                        <li><strong>Analytics Cookies:</strong> Used to understand user behavior and site traffic.</li>
                    </ul>

                    <h2>3. Third-Party Cookies</h2>
                    <p>We use trusted third-party services that set cookies when you interact with our website or applications. These cookies enable us to provide essential features such as analytics, advertising, and secure payments. Examples include:</p>
                    <ul>
                        <li><strong>Analytics:</strong> Google Analytics, Hotjar – used to understand website traffic and usage patterns.</li>
                        <li><strong>Advertising:</strong> Facebook Pixel, LinkedIn Ads – used for targeted ads and measuring campaign performance.</li>
                        <li><strong>Payment Processing:</strong> Stripe – sets cookies to enable secure checkout and fraud prevention.</li>
                    </ul>
                    <p>These third parties collect and process data according to their own privacy and cookie policies. We recommend reviewing their policies to understand how your information is handled.</p>

                    <h2>4. Managing Cookies</h2>
                    <p>You can manage or disable cookies in your browser settings. Please note, disabling cookies may affect functionality of our Services. You may also manage cookie preferences via our website's cookie banner.</p>

                    <h2>5. Consent</h2>
                    <p>We use a cookie consent banner to obtain user consent for non-essential cookies in compliance with GDPR and ePrivacy Directive.</p>

                    <h2>6. Changes to Cookie Policy</h2>
                    <p>We may update this Policy periodically. Continued use of Services indicates acceptance of the updated Policy.</p>

                    <h2>7. Contact Information</h2>
                    <div class="contact-info">
                        <p>For questions regarding our use of cookies:</p>
                        <p><strong>Scanfluence Privacy Office</strong><br>
                            3600 Steeles Avenue East<br>
                            Markham, ON, L3R 9Z7<br>
                            Email: privacy@scanfluence.com</p>
                    </div>
                </div>
            </div>
        </section>
    </div>